<template>
  <div v-if="isMyAccount || !dummy">
    <TextLabel class="">{{ label }}</TextLabel>
    <div v-if="dummy" class="row">
      <div class="col">
        {{ dummy }}&nbsp;
        <template v-if="isMyAccount">
          <router-link
            class="purple"
            :to="{
              name: $routerNames.EDIT,
              params: {
                ...account.params,
                ...$route.params,
              },
              hash: '#stream-accounts-edit',
            }"
            >{{
              $t('_web_profile-info_stream-accounts-add-link', 'Add streams')
            }}</router-link
          >
        </template>
      </div>
    </div>
    <div v-else class="row no-gutters">
      <SocialIcon
        v-for="(value, key) in accountStreams"
        :key="`social_${value}_${key}`"
        :name="`${key}`"
        :size="24"
        class="col-auto px-0 h-mr-4"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextLabel from '@/components/atoms/TextLabel';
import SocialIcon from '@/components/images/Social';

export default {
  name: 'AccountInfoSocials',
  components: {
    SocialIcon,
    TextLabel,
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccountId: 'accountId' }),
    label() {
      return this.$t('_web_profile-info_stream-accounts', 'Streaming');
    },
    accountStreams() {
      return this.account.streams || [];
    },
    isMyAccount() {
      return this.accountId === this.myAccountId;
    },
    dummy() {
      return !this.$lodash.isEmpty(this.accountStreams)
        ? null
        : this.account.isClan
        ? this.$t('_web_profile-info_clan-no-streams', 'No Streams yet')
        : this.$t('_web_profile-info_user-no-streams', 'No Streams yet');
    },
  },
};
</script>

<style lang="scss">
.purple {
  color: #5a58f2 !important;
  &:hover {
    color: #5a58f2;
    opacity: 0.8;
  }
}
</style>
